import { useEffect } from "react";

import type { UseGlobalModalProps } from "./useGlobalModal";

import { GlobalModal } from ".";

export type StandaloneModalProps = UseGlobalModalProps & {
  sandboxId?: string;
  initialPrivacy?: "public" | "unlisted" | "private";
};

const BASE_URL = "https://codesandbox.io";

type Protocol = {
  type: "sandbox-created";
  data: {
    id: string;
    alias: string;
    url: string;
  };
};

export const CreateSandboxModal: React.FC<StandaloneModalProps> = ({
  initialPrivacy,
  sandboxId,
  close,
}) => {
  const url = new URL(`${BASE_URL}/standalone/create`);
  if (sandboxId) {
    url.searchParams.append("sandbox", sandboxId);
  }
  if (initialPrivacy) {
    url.searchParams.append("privacy", initialPrivacy);
  }

  useEffect(() => {
    const listener = (evt: MessageEvent<Protocol>) => {
      if (evt.data?.type === "sandbox-created") {
        window.location.href = evt.data.data.url;
      }
    };

    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, []);

  return (
    <GlobalModal
      fixedHeight={600}
      maxWidth={1000}
      onInteractOutside={close}
      disablePadding
      open
    >
      <iframe
        src={url.toString()}
        style={{
          border: "none",
          outline: "none",
          width: "100%",
          height: 600,
        }}
        title="Create Box"
      />
    </GlobalModal>
  );
};
